(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('cardCvv', function(paymentsService) {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            modal: '=',
            cardType: '=',
            paymentOptions: '='
        },
        templateUrl: (element, attr) => {
            if (attr.templateVersion) {
                return `partials/booking/template?name=CardCvv&version=${attr.templateVersion}`;
            }
            return 'partials/home/directivetemplate?type=CardCvv';
        },
        link(scope) {
            const reAmex = /American\sExpress/i;

            scope.$watch('cardType', function(cardTypeId) {
                scope.isAmex = null; //Hides all messages

                //Amex message shows if card name matches regex
                //Otherwise, default message shows whenever `cardTypeId` is truthy
                //Message is hidden if `cardTypeId` is falsy
                if (cardTypeId) {
                    const paymentOptions = scope.paymentOptions;
                    const cardSpec = paymentOptions && paymentsService.getCardFromId(paymentOptions, cardTypeId);
                    //Title has been renamed to Name in new API.
                    scope.isAmex = reAmex.test(cardSpec && (cardSpec.Title || cardSpec.Name));
                }
            });
        }
    };
});
})();
